<template>
  <div class="h-full flex items-center pt-2">
    <TextInput
      v-model="currentValue"
      compact
      :debounce="true"
      :delay="1200"
      :placeholder="$t('common.search')"
      @input="onInputBoxChanged"
    />
  </div>
</template>

<script>
import { TextInput } from '@/components/Inputs';

export default {
  components: { TextInput },
  data: function () {
    return {
      currentValue: null,
    };
  },
  beforeMount() {
    this.currentValue =
      this.params.api?.getFilterModel()[this.params.column.colId]?.filter || '';
  },
  methods: {
    onInputBoxChanged() {
      if (this.params.api) {
        this.params.api.setFilterModel({
          ...this.params.api.getFilterModel(),
          [this.params.column.colId]: this.currentValue
            ? {
                filterType: 'text',
                type: 'contains',
                filter: this.currentValue,
              }
            : null,
        });
      }
    },

    onFloatingFilterChanged(change) {
      this.currentValue = change;
    },
  },
};
</script>
